ManageShiftController.$inject = [
    '$scope',
    'ScheduleDataServiceV2',
    'TeamScheduleService',
    'userPermissions',
    'hFormsService',
    'hEvent',
    'modalData',
    'onSave',
    'onDelete',
    'onStart',
    'onError',
    'onPublish',
    'onRestore'
];

function ManageShiftController(
    $scope,
    ScheduleDataServiceV2,
    TeamScheduleService,
    userPermissions,
    hFormsService,
    hEvent,
    modalData,
    onSave,
    onDelete,
    onStart,
    onError,
    onPublish,
    onRestore
) {
    let self = this;

    const _manageShiftFormClass = hFormsService.getForm("manageShiftForm");
    self._manageShiftForm = new _manageShiftFormClass($scope, 'schedule-manage-shift-form');

    self.mode = modalData.mode;
    self.shiftDate = modalData?.day || modalData?.shift?.day || ScheduleDataServiceV2.getShiftDay(modalData.shift);

    let defaultEventData;
    let trackedUserId;
    let isLocked = modalData.isLocked;
    let canApproveAndPublishSchedule = false;
    let canManageSchedule = false;
    let hasManageHourlyWagesAccess = false;
    let canPublish = false;
    let deletedRevenueCenters = [];

    const init = () => {

        if (onStart) {
            onStart();
        }

        TeamScheduleService.getActiveBrand()
            .then((brand) => {
                deletedRevenueCenters = brand.deleted_revenue_centers;
                ScheduleDataServiceV2.setRevenueCenters(brand.revenue_centers);

                userPermissions.getBrandPolicy(brand.id)
                    .then((policyParser) => {
                        canApproveAndPublishSchedule = policyParser.has(userPermissions.PERMISSIONS.PUBLISH_SCHEDULE);
                        canManageSchedule = policyParser.has(userPermissions.PERMISSIONS.MANAGE_SCHEDULE);
                        hasManageHourlyWagesAccess = policyParser.hasAny([userPermissions.PERMISSIONS.MANAGE_HOURLY_EMPLOYEES_WAGES, userPermissions.PERMISSIONS.VIEW_HOURLY_EMPLOYEES_WAGES]);
                        canPublish = canApproveAndPublishSchedule && !isLocked;

                        defaultEventData = {
                            'brand_id': modalData.brand_id,
                            'schedule_id': modalData.schedule_id,
                            'user_with_approval': canApproveAndPublishSchedule,
                            'tag': 'schedule_creation',
                        };
                        trackedUserId = modalData.shift?.user_id;

                        loadShiftForm();
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            });
    }

    self.hide = () => {
        $scope.$hide();
    };

    const loadShiftForm = () => {
        const eventData = _.extend({
            'shift_id': (modalData.mode == 'EDIT' && modalData.shift.id) || null,
            'shift_status': trackedUserId ? 'ASSIGNED' : 'UNASSIGNED',
            'user_id': trackedUserId || null,
            'event_status': 'SUCCESS',
        }, defaultEventData);

        hEvent.dwhTrack(modalData.mode == 'EDIT' ? 'schedule_edit_shift_modal_open' : 'schedule_create_shift_modal_open', eventData);

        const revenueCenters = {...ScheduleDataServiceV2.revenueCenters};
        deletedRevenueCenters.forEach(revenueCenter => {
            revenueCenters[revenueCenter.id] = revenueCenter;
        });

        self._manageShiftForm.load({
            pendingApproval: modalData.pendingApproval,
            isLocked: isLocked,
            canPublish: canPublish,
            viewType: modalData.viewType,
            canApproveAndPublish: canApproveAndPublishSchedule,
            canManageSchedule: canManageSchedule,
            activeScheduleView: modalData.activeScheduleView,
            schedule_id: modalData.schedule_id,
            day: modalData.day || moment(modalData.shift.start_time).format("MMM DD, YYYY"),
            shift: modalData.shift,
            revenueCenters: revenueCenters,
            hasManageHourlyWagesAccess: hasManageHourlyWagesAccess,
            employeeId: modalData.user_id,
            assigneeId: modalData.shift.assignee_id,
            slotGroupId: modalData.assigneeId,
            GFEAppliedCity: modalData.GFEAppliedCity,
            position_code: modalData.position_code,
            role_id: modalData.role_id,
            brand_id: modalData.brand_id,
            action: modalData.action,
            mode: modalData.mode,
            category: modalData.category,
            userMinorTypes: modalData.userMinorTypes,
            userChanged: onSelectedUserChanged,
        });
    };

    const onSelectedUserChanged = (userId) => {
        trackedUserId = userId;
    };

    //Create new shift call
    const createNewShiftCall = (shiftToSend, publish) => {
        const eventData = _.extend({
            'shift_status': trackedUserId ? 'ASSIGNED' : 'UNASSIGNED',
            'user_id': trackedUserId,
            'shift_action': 'ADD',
        }, defaultEventData);
        TeamScheduleV2API.createNewShift(modalData.brand_id, modalData.schedule_id || shiftToSend.schedule_id, shiftToSend)
            .then((shift) => {
                let eventName = 'schedule_create_shift_modal_save';

                if (publish) {
                    eventName += '_publish';
                }

                let shiftAssignee = null;
                for (const role of shift.roles) {
                    for (const roleDay of role.role_days) {
                        const assignee = roleDay.assignees.find(assignee => assignee.user_id === trackedUserId);

                        if (assignee?.assignee_shifts.length) {
                            shiftAssignee = assignee;
                            break;
                        }
                    }

                    if (shiftAssignee) {
                        break;
                    }
                }
                eventData.shift_id = shiftAssignee?.assignee_shifts?.[0].id;
                eventData.event_status = 'SUCCESS';
                hEvent.dwhTrack(eventName, eventData);
                onSave(shift, modalData.action, publish);
                self.hide();
            }, (err) => {
                let eventName = 'schedule_create_shift_modal_save';
                if (publish) {
                    eventName += '_publish';
                }
                eventData.event_status = 'FAIL';
                hEvent.dwhTrack(eventName, eventData);
                onError && onError(err, "create");
                console.error(err);
                self.hide();
            });
    };

    self._manageShiftForm.onPublish(() => {
        onPublish(modalData.shift, modalData.action);
        self.hide();
    });


    self._manageShiftForm.onRestoreConsent((shift) => {
        onSave(shift, modalData.action);
        self.hide();
    });

    self._manageShiftForm.onRestore(() => {
        onRestore(modalData.shift, modalData.action);
        self.hide();
    });

    self._manageShiftForm.onSaved((shift, publish) => {
        const newShift = angular.copy(shift);
        newShift.user_id = newShift.user_id || null;
        newShift.status = "UNPUBLISHED";

        const shiftToSend = {
            position_code: newShift.position_code,
            end_time: newShift.end_time,
            user_id: newShift.user_id,
            schedule_id: newShift.schedule_id,
            start_time: newShift.start_time,
            labels: [],
            note: newShift.note,
            weight: newShift.weight,
            job_titles: newShift.job_titles,
            is_requested_by_assignee: newShift.is_requested_by_assignee
        };

        if (newShift.incentive_payments) {
            shiftToSend["incentive_payments"] = newShift.incentive_payments;
        }

        if (newShift.forecasted_recurrence) {
            shiftToSend['forecasted_recurrence'] = newShift.forecasted_recurrence;
        }

        if (ScheduleDataServiceV2.shiftsTemplates && ScheduleDataServiceV2.shiftsTemplates[newShift.code] && ScheduleDataServiceV2.shiftsTemplates[newShift.code].id) {
            shiftToSend["template_id"] = ScheduleDataServiceV2.shiftsTemplates[newShift.code].id;

        } else {
            shiftToSend["color"] = null;
        }

        if (newShift.breaks) {
            shiftToSend["breaks"] = newShift.breaks;
        }

        const shiftDay = ScheduleDataServiceV2.getShiftDay(newShift);
        const newRole = ScheduleDataServiceV2.getRoleFromPosition(newShift.position_code, shiftDay);

        if (newRole) {
            const roleDayId = ScheduleDataServiceV2.mappings['day_role'][shiftDay + '_' + newRole.id];
            const assigneeId = roleDayId && ScheduleDataServiceV2.mappings['user_roleday'][newShift.user_id + '_' + roleDayId];

            if (assigneeId) {
                shiftToSend['role_id'] = newRole.id;
                shiftToSend['assignee_id'] = assigneeId;
                delete shiftToSend['user_id'];
                delete shiftToSend['position_code'];

            } else if (shiftToSend['user_id']) {
                shiftToSend['role_id'] = newRole.id;
                delete shiftToSend['position_code'];
            }

        }

        if (shift.revenue_center_id) {
            shiftToSend['revenue_center_id'] = shift.revenue_center_id;
        }

        if (shift.labels) {
            shiftToSend.labels = shift.labels.map((label) => label.id);
        }

        if (shift.day_parts) {
            shiftToSend.day_parts = shift.day_parts;
        }

        if (!shift.shift_id) {

            if (!shiftToSend.schedule_id) {
                modalData.getScheduleId(true)
                    .then((scheduleId) => {
                        shiftToSend.schedule_id = scheduleId;
                        createNewShiftCall(shiftToSend, publish);
                    });
            } else {
                createNewShiftCall(shiftToSend, publish);
            }
        } else {
            const eventData = _.extend({
                'shift_id': shift.shift_id,
                'shift_status': trackedUserId ? 'ASSIGNED' : 'UNASSIGNED',
                'user_id': trackedUserId,
                'shift_action': 'EDIT',
            }, defaultEventData);

            TeamScheduleV2API.editShift(modalData.brand_id, modalData.schedule_id, shift.shift_id, shiftToSend)
                .then((shift) => {
                    let eventName = 'schedule_edit_shift_modal_save';

                    if (publish) {
                        eventName += '_publish';
                    }
                    eventData.event_status = 'SUCCESS';
                    hEvent.dwhTrack(eventName, eventData);

                    onSave(shift, modalData.action, publish);
                    self.hide();
                }, (err) => {
                    let eventName = 'schedule_edit_shift_modal_save';
                    if (publish) {
                        eventName += '_publish';
                    }
                    eventData.event_status = 'FAIL';
                    hEvent.dwhTrack(eventName, eventData);
                    if (err && err.data && err.data.status === 'SCHEDULE_LOCKED') {
                        onError && onError(err, "edit");
                        self.hide();
                    }
                    else if (err.status === 400) {
                        self._manageShiftForm.onError(err.data.status);
                    }
                    console.error(err);
                });
        }
    });

    self._manageShiftForm.onSaveShiftCanceled(() => {
        self.hide();
    });

    self._manageShiftForm.onDelete((shift, isRequestedByAssignee) => {
        const params = { 'is_requested_by_assignee': isRequestedByAssignee };

        const eventData = _.extend({
            'shift_id': modalData.shift.id,
            'user_id': trackedUserId,
            'shift_status': trackedUserId ? 'ASSIGNED' : 'UNASSIGNED',
            'shift_action': 'DELETE',
        }, defaultEventData);

        TeamScheduleAPI.deleteScheduleShift(ScheduleDataServiceV2.scheduleId, modalData.shift.assignee_id, modalData.shift.id, params)
            .then((res) => {
                eventData.event_status = 'SUCCESS';
                hEvent.dwhTrack('schedule_edit_shift_modal_delete_shift', eventData);
                setTimeout(() => {
                    onDelete(shift, res);
                }, 1);

                self.hide();
            },
                (err) => {
                    eventData.event_status = 'FAIL';
                    hEvent.dwhTrack('schedule_edit_shift_modal_delete_shift', eventData);
                    console.error(err);
                    onError && onError(err, "delete");
                    self.hide();
                });
    });

    init();
}

export const getManageShiftModal = function (modalData, onStart, onSave, onDelete, onPublish, onRestore, onError) {
    return {
        controller: ManageShiftController,
        controllerAs: '$ctrl',
        templateUrl: '../modules/team_schedule/employer/shifts/modals/manage-shift-modal/manage-shift.modal.html',
        show: true,
        backdrop: 'static',
        resolve: {
            modalData: modalData,
            onStart: onStart,
            onSave: onSave,
            onDelete: onDelete,
            onPublish: onPublish,
            onRestore: onRestore,
            onError: onError,
        },
        onHide: (modal) => {
            $('body').removeClass('is-manage-shift-modal-open');
            modal.$scope.$destroy();
        }
    };
};
